import JSZip from "jszip";
import * as XLSX from "xlsx";

const OFFICE_SNIPPET_LEN = 400;

function isImageFile(file) {
  const n = (file.name || "").toLowerCase();
  const t = file.type || "";
  return (
    t.startsWith("image/") ||
    /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(n)
  );
}

function isPdfFile(file) {
  const n = (file.name || "").toLowerCase();
  const t = file.type || "";
  return t === "application/pdf" || n.endsWith(".pdf");
}

function isDocxFile(file) {
  return (file.name || "").toLowerCase().endsWith(".docx");
}

function isExcelFile(file) {
  const n = (file.name || "").toLowerCase();
  return /\.(xlsx|xls|csv)$/i.test(n);
}

function isTxtFile(file) {
  const n = (file.name || "").toLowerCase();
  const t = (file.type || "").toLowerCase();
  return t.startsWith("text/plain") || n.endsWith(".txt");
}

/**
 * @returns {Promise<{ kind: string, url?: string, text?: string, name?: string }>}
 */
export async function buildAttachmentPreview(file) {
  const name = file.name || "файл";

  if (isImageFile(file)) {
    const url = URL.createObjectURL(file);
    return { kind: "image", url, name };
  }

  if (isPdfFile(file)) {
    const url = URL.createObjectURL(file);
    return { kind: "pdf", url, name };
  }

  if (isDocxFile(file)) {
    try {
      const buf = await file.arrayBuffer();
      const zip = await JSZip.loadAsync(buf);
      const entry = zip.file("word/document.xml");
      if (!entry) {
        return { kind: "text", text: "Не удалось прочитать документ", name };
      }
      const xml = await entry.async("string");
      const text = xml
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, OFFICE_SNIPPET_LEN);
      return { kind: "text", text: text || "(пусто)", name };
    } catch {
      return { kind: "text", text: "Не удалось прочитать документ", name };
    }
  }

  if (isTxtFile(file)) {
    try {
      const text = await file.text();
      const snippet = text.replace(/\s+/g, " ").trim().slice(0, OFFICE_SNIPPET_LEN);
      return { kind: "text", text: snippet || "(пусто)", name };
    } catch {
      return { kind: "text", text: "Не удалось прочитать TXT", name };
    }
  }

  if (isExcelFile(file)) {
    const lower = name.toLowerCase();
    if (lower.endsWith(".csv")) {
      try {
        const text = await file.text();
        const snippet = text.replace(/\s+/g, " ").trim().slice(0, OFFICE_SNIPPET_LEN);
        return { kind: "text", text: snippet || "(пусто)", name };
      } catch {
        return { kind: "text", text: "Не удалось прочитать CSV", name };
      }
    }
    try {
      const buf = await file.arrayBuffer();
      const wb = XLSX.read(buf, { type: "array" });
      const first = wb.SheetNames[0];
      if (!first) {
        return { kind: "text", text: "(пустая книга)", name };
      }
      const csv = XLSX.utils.sheet_to_csv(wb.Sheets[first] || {});
      const snippet = csv.replace(/\s+/g, " ").trim().slice(0, OFFICE_SNIPPET_LEN);
      return { kind: "text", text: snippet || "(пусто)", name };
    } catch {
      return { kind: "text", text: "Не удалось прочитать таблицу", name };
    }
  }

  if ((file.name || "").toLowerCase().endsWith(".doc")) {
    return {
      kind: "text",
      text: "Формат .doc — превью текста недоступно",
      name,
    };
  }

  return { kind: "name", text: name, name };
}
